import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, Col, Form, Modal, Row } from "react-bootstrap";
import { Tooltip, useMediaQuery, useTheme } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import Select from "react-select";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
var authHeaders = function() {
    return {
        Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
    };
};
var CountBadge = function(param) {
    var count = param.count, brand = param.brand;
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3 py-1 text-center",
        style: {
            color: brand ? "#A46A00" : "#F95057",
            backgroundColor: brand ? "#FFF4D8" : "#FFE3E3",
            borderRadius: 20,
            minWidth: 80
        },
        children: [
            count || 0,
            " รายการ"
        ]
    });
};
export default function ShopProductBan() {
    var _editing_branch_shShop, _editing_branch, _editing_branch1, _editing_branch2;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var _useState = _sliced_to_array(useState([]), 2), branches = _useState[0], setBranches = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), search = _useState2[0], setSearch = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), editing = _useState3[0], setEditing = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), brands = _useState4[0], setBrands = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), products = _useState5[0], setProducts = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), brandIds = _useState6[0], setBrandIds = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), productIds = _useState7[0], setProductIds = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), loading = _useState8[0], setLoading = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), saving = _useState9[0], setSaving = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), message = _useState10[0], setMessage = _useState10[1];
    var _useState11 = _sliced_to_array(useState(1), 2), pageId = _useState11[0], setPageId = _useState11[1];
    var _useState12 = _sliced_to_array(useState(20), 2), pageSize = _useState12[0], setPageSize = _useState12[1];
    var _useState13 = _sliced_to_array(useState(1), 2), totalPage = _useState13[0], setTotalPage = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), totalAmount = _useState14[0], setTotalAmount = _useState14[1];
    var load = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _response_data, _result_pagination, _result_pagination1, response, result, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        http.post(endPoint.SHOP_PRODUCT_BAN_LIST, {
                            search: search,
                            page: pageId,
                            pageSize: pageSize
                        }, {
                            headers: authHeaders()
                        })
                    ];
                case 2:
                    response = _state.sent();
                    result = (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) || {};
                    setBranches(Array.isArray(result) ? result : result.data || []);
                    setTotalPage(((_result_pagination = result.pagination) === null || _result_pagination === void 0 ? void 0 : _result_pagination.totalPages) || 1);
                    setTotalAmount(((_result_pagination1 = result.pagination) === null || _result_pagination1 === void 0 ? void 0 : _result_pagination1.total) || 0);
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    setMessage({
                        type: "danger",
                        text: "ไม่สามารถโหลดข้อมูลสาขาร้านค้าได้"
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        pageId,
        pageSize,
        search
    ]);
    useEffect(function() {
        load();
    }, [
        load
    ]);
    var handleSearch = function() {
        setPageId(1);
        setSearch(filterText.trim());
    };
    var openEditor = function() {
        var _ref = _async_to_generator(function(branch, type) {
            var _response_data, response, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setMessage(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            http.post(endPoint.SHOP_PRODUCT_BAN_OPTIONS, {}, {
                                headers: authHeaders()
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        data = (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) || {};
                        setBrands((data.brands || []).map(function(item) {
                            return {
                                value: item.set_brand_id,
                                label: item.set_brand_name || item.set_brand_nameen || "#".concat(item.set_brand_id)
                            };
                        }));
                        setProducts((data.products || []).map(function(item) {
                            return {
                                value: item.pd_product_id,
                                label: "".concat(item.pd_product_code || "-", " - ").concat(item.pd_product_nameen || item.pd_product_nameth || "-")
                            };
                        }));
                        setBrandIds((branch.ShBranchBanBrand || []).map(function(item) {
                            return item.sh_branch_ban_brand_brandid;
                        }));
                        setProductIds((branch.ShBranchBanProduct || []).map(function(item) {
                            return item.sh_branch_ban_product_productid;
                        }));
                        setEditing({
                            branch: branch,
                            type: type
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setMessage({
                            type: "danger",
                            text: "ไม่สามารถโหลดรายการสำหรับตั้งค่า Ban ได้"
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function openEditor(branch, type) {
            return _ref.apply(this, arguments);
        };
    }();
    var save = function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            http.post(endPoint.SHOP_PRODUCT_BAN_SAVE, {
                                branchId: editing.branch.sh_branch_id,
                                brandIds: brandIds,
                                productIds: productIds
                            }, {
                                headers: authHeaders()
                            })
                        ];
                    case 2:
                        _state.sent();
                        setEditing(null);
                        setMessage({
                            type: "success",
                            text: "บันทึกข้อมูล Ban เรียบร้อยแล้ว"
                        });
                        return [
                            4,
                            load()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        setMessage({
                            type: "danger",
                            text: "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                        });
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    var actionButton = function(row, type) {
        var brand = type === "brand";
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: brand ? "จัดการแบรนด์ที่ Ban" : "จัดการสินค้าที่ Ban",
            children: /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "border-0",
                onClick: function() {
                    return openEditor(row, type);
                },
                style: {
                    color: brand ? "#A46A00" : "#F95057",
                    borderRadius: 40,
                    background: brand ? "#FFF4D8" : "#FFE3E3",
                    padding: 5,
                    lineHeight: 0
                },
                children: brand ? /*#__PURE__*/ _jsx(BlockIcon, {
                    style: {
                        fontSize: 21
                    }
                }) : /*#__PURE__*/ _jsx(Inventory2OutlinedIcon, {
                    style: {
                        fontSize: 21
                    }
                })
            })
        });
    };
    var columns = useMemo(function() {
        return [
            {
                name: "รหัสร้านค้า",
                selector: function(row) {
                    var _row_shShop;
                    return ((_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_code) || "-";
                },
                sortable: true
            },
            {
                name: "ร้านค้า",
                selector: function(row) {
                    var _row_shShop;
                    return ((_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_name) || "-";
                },
                sortable: true
            },
            {
                name: "รหัสสาขา",
                selector: function(row) {
                    return row.sh_branch_code || "-";
                },
                sortable: true
            },
            {
                name: "สาขา",
                selector: function(row) {
                    return row.sh_branch_name || "-";
                },
                sortable: true
            },
            {
                name: "แบรนด์ที่ Ban",
                center: "true",
                cell: function(row) {
                    var _row_ShBranchBanBrand;
                    return /*#__PURE__*/ _jsx(CountBadge, {
                        count: (_row_ShBranchBanBrand = row.ShBranchBanBrand) === null || _row_ShBranchBanBrand === void 0 ? void 0 : _row_ShBranchBanBrand.length,
                        brand: true
                    });
                }
            },
            {
                name: "สินค้าที่ Ban",
                center: "true",
                cell: function(row) {
                    var _row_ShBranchBanProduct;
                    return /*#__PURE__*/ _jsx(CountBadge, {
                        count: (_row_ShBranchBanProduct = row.ShBranchBanProduct) === null || _row_ShBranchBanProduct === void 0 ? void 0 : _row_ShBranchBanProduct.length
                    });
                }
            },
            {
                name: "จัดการ",
                center: "true",
                width: "140px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex gap-2",
                        children: [
                            actionButton(row, "brand"),
                            actionButton(row, "product")
                        ]
                    });
                }
            }
        ];
    }, []);
    var activeOptions = (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? brands : products;
    var activeIds = (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? brandIds : productIds;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 ps-2 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shop",
                                        className: "tc-7 text-decoration-none",
                                        children: "จัดการร้านค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    "aria-current": "page",
                                    children: "จัดการ Ban สินค้าและแบรนด์"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2 ps-2",
                        children: "จัดการ Ban สินค้า และ แบรนด์ สำหรับสาขาร้านค้า"
                    })
                ]
            }),
            message && /*#__PURE__*/ _jsx("div", {
                className: "alert alert-".concat(message.type, " py-2"),
                role: "alert",
                children: message.text
            }),
            /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsx(CardBody, {
                        children: /*#__PURE__*/ _jsx(Row, {
                            className: "justify-content-end",
                            children: /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 8,
                                lg: 5,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            value: filterText,
                                            placeholder: "ค้นหารหัสหรือชื่อร้านค้า / สาขา",
                                            onChange: function(event) {
                                                return setFilterText(event.target.value);
                                            },
                                            onKeyDown: function(event) {
                                                return event.key === "Enter" && handleSearch();
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            className: "btn btn-dg px-4 text-nowrap",
                                            onClick: handleSearch,
                                            children: "ค้นหา"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                        item: branches,
                        columns: columns,
                        isSelectRows: false,
                        currentPage: pageId,
                        currentPageSize: pageSize,
                        onChangePage: setPageId,
                        onChangePageSize: function(size) {
                            setPageSize(size);
                            setPageId(1);
                        },
                        totalPage: totalPage,
                        totalAmount: totalAmount,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: Boolean(editing),
                onHide: function() {
                    return !saving && setEditing(null);
                },
                size: "lg",
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: !saving,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            className: "fs-20",
                            children: (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? "จัดการแบรนด์ที่ Ban" : "จัดการสินค้าที่ Ban"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "p-3 mb-3 bg-light rounded",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fw-bold tc-10",
                                        children: (editing === null || editing === void 0 ? void 0 : (_editing_branch = editing.branch) === null || _editing_branch === void 0 ? void 0 : (_editing_branch_shShop = _editing_branch.shShop) === null || _editing_branch_shShop === void 0 ? void 0 : _editing_branch_shShop.sh_shop_name) || "-"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-muted fs-14",
                                        children: [
                                            "สาขา ",
                                            (editing === null || editing === void 0 ? void 0 : (_editing_branch1 = editing.branch) === null || _editing_branch1 === void 0 ? void 0 : _editing_branch1.sh_branch_name) || "-",
                                            " (",
                                            (editing === null || editing === void 0 ? void 0 : (_editing_branch2 = editing.branch) === null || _editing_branch2 === void 0 ? void 0 : _editing_branch2.sh_branch_code) || "-",
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3 p-0",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1 z-3",
                                        children: (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? "แบรนด์ที่ Ban" : "สินค้าที่ Ban"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        className: "w-100 select-st-3 z-2",
                                        isMulti: true,
                                        isClearable: true,
                                        closeMenuOnSelect: false,
                                        options: activeOptions,
                                        value: activeOptions.filter(function(item) {
                                            return activeIds.includes(item.value);
                                        }),
                                        onChange: function(items) {
                                            var ids = (items || []).map(function(item) {
                                                return item.value;
                                            });
                                            (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? setBrandIds(ids) : setProductIds(ids);
                                        },
                                        placeholder: (editing === null || editing === void 0 ? void 0 : editing.type) === "brand" ? "ค้นหาและเลือกแบรนด์" : "ค้นหารหัสหรือชื่อสินค้า",
                                        noOptionsMessage: function() {
                                            return "ไม่พบข้อมูล";
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Text, {
                                        className: "text-muted",
                                        children: "เลือกได้มากกว่า 1 รายการ และกดเครื่องหมาย \xd7 เพื่อนำรายการออก"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-st-6 py-2 px-4",
                                onClick: function() {
                                    return setEditing(null);
                                },
                                disabled: saving,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn btn-dg py-2 px-4",
                                onClick: save,
                                disabled: saving,
                                children: saving ? "กำลังบันทึก..." : "บันทึก"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
